import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { enTranslatedStrings } from "./en";
import i18next from "i18next";
import { esTranslatedStrings } from "./es";
import { ruTranslatedStrings } from "./ru";
import { caTranslatedStrings } from "./ca";

export const getLanguage = () => {
  let language = i18next.language || window.localStorage.i18nextLng;
  
  if (language === undefined) {
    language = localStorage.getItem('taskgen_interface_language') ?? 'en';
  }

  return language;
}

i18n
  .use(initReactI18next)
  .init({
    lng: getLanguage(),
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    resources: {
      // English
      en: {
        translation: enTranslatedStrings
      },
      // English
      es: {
        translation: esTranslatedStrings
      },
      // English
      ca: {
        translation: caTranslatedStrings
      },
      // English
      ru: {
        translation: ruTranslatedStrings
      }
    },
  });

export default i18n;